import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useVisibilityFilter } from './useVisibilityFilter';

export const VisibilityFilter = ({ value, setFilters, visibilityOptions }) => {
  const { formSchema, onSubmit } = useVisibilityFilter({ setFilters });
  const selectedOption = visibilityOptions.find((i) => i.value === value) ?? visibilityOptions[0];
  return (
    <Formik
      initialValues={{ visibility: selectedOption || visibilityOptions[0] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="visibility"
          label="Visibility"
          placeholder="Visibility"
          size="small"
          component={FormSelect}
          options={visibilityOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

VisibilityFilter.propTypes = {
  value: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
  visibilityOptions: PropTypes.array.isRequired,
};

VisibilityFilter.defaultProps = {
  value: '',
};
